var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useReducer, lazy, Suspense, useState } from "react";
import "../app/App.scss";
import Body from "../features/common/elements/Body";
import { OrgInsightsBody } from "../features/organization-insights/OrgInsightsBody";
import PlanView from "../features/continuous-improvement/export/PlanView";
import LaborMarketExportView from "../features/lightcast/LaborMarketExportView";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import FacultySuccessExportView from "src/features/faculty-success/export/FacultySuccessExportView";
import MissionAndOutcomesExportView from "src/features/strategy/mission-and-outcomes/export/MissionAndOutcomesExportView";
import SllExportView from "src/features/sll/export/SllExportView";
import CesHtmlView from "src/features/ces/export/HtmlView";
import HomeComponent from "src/features/insights/home/HomeComponent";
import UnauthorizedComponent from "src/features/insights/UnauthorizedComponent";
import IncorrectURLComponent from "src/features/insights/IncorrectURLComponent";
import OrgProfileComponent from "src/features/insights/OrgProfileComponent";
import OrgDetailComponent from "src/features/insights/OrgDetailComponent";
import AcademicsAndOffices from "src/features/insights/academicsAndOffices/AcademicsAndOffices";
import { InsightsSettings } from "src/features/insights/settings/InsightsSettings";
import SiteMap from "src/features/insights/SiteMap";
import { InsightsHeaderSidebar } from "src/features/insights/InsightsHeaderSidebar";
import { PlanningHeaderSidebar } from "src/features/insights/PlanningHeaderSidebar";
import { IntlProvider } from "react-intl";
import { pig } from "../static/js/pig.js";
import ENGLISH from "../i18n/languages/en-US.json";
import { AppContext } from "../contexts/AppContext";
import Loader from "src/features/common/elements/Loader";
import SkipMenu from "src/features/common/elements/SkipMenu";
import { initiateGainsight } from "../static/js/gainsight_integration";
import { defaultInstitution, defaultMembership, defaultInsightsUser } from "src/features/common/interfaces/Interface";
import { sendRequest } from "src/common/http";
// Lazy load development-only component
var MirageStateComponent = lazy(function () { return import("src/mirage/MirageStateComponent"); });
var defaultAction = {
    locale: "",
    type: "",
    leads: [],
    component: "",
    institution: defaultInstitution,
    membership: defaultMembership,
    showLightcastPreview: false,
    user: defaultInsightsUser,
    tab: "",
    integratedProducts: null,
    nodeAccessContributor: null,
    institutionsList: [],
    selectedInstitution: null,
    breadcrumb: null,
    showUnauthorized: false,
    cesUserRole: null,
    outcomesTerminology: null
};
var reducer = function (state, action) {
    var componentLoaded = state.componentLoaded;
    switch (action.type) {
        case "setLocale":
            return setLocale(state, action.locale);
        case "setUser":
            return __assign(__assign({}, state), { user: action.user });
        case "setLeads":
            return __assign(__assign({}, state), { leads: action.leads });
        case "setInstitution":
            return __assign(__assign({}, state), { institution: action.institution });
        case "setInstitutionsList":
            return __assign(__assign({}, state), { institutionsList: action.institutionsList });
        case "setSelectedInstitution":
            return __assign(__assign({}, state), { selectedInstitution: action.selectedInstitution });
        case "setNodeAccess":
            return __assign(__assign({}, state), { nodeAccess: false });
        case "setMembership":
            return __assign(__assign({}, state), { membership: action.membership });
        case "setComponentLoaded":
            componentLoaded[action.component] = true;
            return __assign(__assign({}, state), { componentLoaded: componentLoaded });
        case "setPreviewModalStatus":
            componentLoaded.openPreviewModal = false;
            return __assign(__assign({}, state), { componentLoaded: componentLoaded });
        case "SetSelectedTabView":
            return __assign(__assign({}, state), { tab: action.tab });
        case "setLightcastPreviewFlag":
            return __assign(__assign({}, state), { institution: __assign(__assign({}, state.institution), { showLightcastPreview: action.showLightcastPreview }) });
        case "setIntegratedProducts":
            return state.integratedProducts
                ? state
                : __assign(__assign({}, state), { integratedProducts: action.integratedProducts });
        case "setNodeAccessContributor":
            return __assign(__assign({}, state), { nodeAccessContributor: action.nodeAccessContributor });
        case "setBreadcrumb":
            return __assign(__assign({}, state), { breadcrumb: action.breadcrumb });
        case "setShowUnauthorized":
            return __assign(__assign({}, state), { showUnauthorized: action.showUnauthorized });
        case "setCesUserRole":
            return __assign(__assign({}, state), { cesUserRole: action.cesUserRole });
        case "setOutcomesTerminology":
            return __assign(__assign({}, state), { outcomesTerminology: action.outcomesTerminology });
        default:
            return state;
    }
};
var setLocale = function (state, locale) {
    switch (locale) {
        case "pig": {
            return __assign(__assign({}, state), { locale: "en-US", messages: pig(ENGLISH) });
        }
        default: {
            return __assign(__assign({}, state), { locale: "en-US", messages: ENGLISH });
        }
    }
};
var initialState = {
    locale: "en-US",
    messages: ENGLISH,
    institution: defaultAction.institution,
    user: defaultInsightsUser,
    leads: [],
    membership: defaultMembership,
    tab: "institution-strategy",
    componentLoaded: {
        selectedTab: "item-1",
        collapseSideNav: false,
        openPreviewModal: false,
        institution: false,
        membership: false
    },
    integratedProducts: null,
    nodeAccess: true,
    nodeAccessContributor: null,
    institutionsList: [],
    selectedInstitution: null,
    breadcrumb: null,
    showUnauthorized: false,
    cesUserRole: null,
    outcomesTerminology: null
};
function getUuid(type) {
    var pathname = window.location.pathname;
    var regexMap = {
        organization: /\/organization\/([a-z0-9\-]{36})/,
        institution: /\/institution\/([a-z0-9\-]{36})/,
        program: /\/program\/([a-z0-9\-]{36})/
    };
    var regex = regexMap[type];
    var match = pathname.match(regex);
    return match ? match[1] : null;
}
function App() {
    var _a, _b, _c;
    var REDIRECT_URI = runConfig.REDIRECT_URI;
    var _d = useReducer(reducer, initialState), state = _d[0], dispatch = _d[1];
    // Helper function to check if current route needs non-SA integrated products
    var hasSaIntegratedProducts = function (pathname) {
        var path = pathname || window.location.pathname;
        // Check for exact matches and pattern matches
        var patterns = [
            /^\/insights\/home$/, // /insights/home
            /^\/insights\/academic_office$/, // /insights/academic_office
            /^\/insights\/faculty_success\/reporting_year\/[^\/]+\/mapping_id\/[^\/]+\/html$/, // /insights/faculty_success/reporting_year/:reporting_year_uuid/mapping_id/:mapping_id/html
            /^\/insights\/sll\/reporting_year\/[^\/]+\/html$/, // /insights/sll/reporting_year/:reporting_year_uuid/html
            /^\/insights\/institution\/[^\/]+$/,
            /^\/insights\/institution\/[^\/]+\/organization\/[^\/]+$/,
            /^\/insights\/planning\/home$/ // /insights/planning/home
        ];
        return patterns.some(function (pattern) { return pattern.test(path); });
    };
    var loadCesUserRoleIfNeeded = function () {
        if (state.institution.platformUuid !== "" && !state.cesUserRole) {
            var applyResult = function (result) {
                dispatch(__assign(__assign({}, defaultAction), { type: "setCesUserRole", cesUserRole: result }));
            };
            sendRequest({ uri: "/ces/ce-user-role", camelize: true }, applyResult);
        }
    };
    // Centralized function to load integrated products if needed
    var loadIntegratedProductsIfNeeded = function (currentPath) {
        var needsIntegratedProducts = state.institution.platformUuid !== "" &&
            !state.integratedProducts &&
            hasSaIntegratedProducts(currentPath);
        if (needsIntegratedProducts) {
            var applyResult = function (result) {
                setIntegratedProducts(result);
            };
            sendRequest({
                uri: "/home/integrated-products",
                camelize: true
            }, applyResult);
        }
        return needsIntegratedProducts;
    };
    // Route change detector component (runs inside Router)
    var RouteChangeDetector = function () {
        var location = useLocation();
        useEffect(function () {
            loadIntegratedProductsIfNeeded(location.pathname);
        }, [location.pathname, state.institution.platformUuid, state.integratedProducts]);
        return null; // This component doesn't render anything
    };
    var SkipMenuManager = function () {
        var location = useLocation();
        var _a = useState(true), showNavigation = _a[0], setShowNavigation = _a[1];
        useEffect(function () {
            var navElement = document.getElementById('mainnav');
            var isNavigationVisible = !!navElement && !navElement.classList.contains('hamburger-hide');
            setShowNavigation(isNavigationVisible);
        }, [location.pathname]);
        return _jsx(SkipMenu, { showNavigation: showNavigation });
    };
    useEffect(function () {
        var queryString = window.location.search;
        var param = new URLSearchParams(queryString);
        var paramlocale = param.get("locale");
        var locale = paramlocale ? paramlocale : "";
        dispatch(__assign(__assign({}, defaultAction), { type: "setLocale", locale: locale }));
    }, []);
    useEffect(function () {
        var applyResult = function (result) {
            if (result) {
                dispatch(__assign(__assign({}, defaultAction), { type: "setInstitution", institution: result }));
            }
            else {
                dispatch(__assign(__assign({}, defaultAction), { type: "setNodeAccess" }));
            }
            dispatch(__assign(__assign({}, defaultAction), { type: "setComponentLoaded", component: "institution" }));
        };
        var onError = function (error) {
            if (error.status === 403) {
                dispatch(__assign(__assign({}, defaultAction), { type: "setShowUnauthorized", showUnauthorized: true }));
                dispatch(__assign(__assign({}, defaultAction), { type: "setComponentLoaded", component: "institution" }));
                dispatch(__assign(__assign({}, defaultAction), { type: "setComponentLoaded", component: "membership" }));
            }
            else {
                window.location.href = REDIRECT_URI;
            }
        };
        var organizationUuid = getUuid("organization");
        var institutionUuid = getUuid("institution");
        var programUuid = getUuid("program");
        // Build query parameters more cleanly
        var uuidParams = [
            { key: "organization_uuid", value: organizationUuid },
            { key: "program_uuid", value: programUuid },
            { key: "institution_uuid", value: institutionUuid }
        ];
        var params = uuidParams
            .filter(function (param) { return param.value; })
            .map(function (param) { return "".concat(param.key, "=").concat(param.value); });
        var queryString = params.length > 0 ? "?".concat(params.join("&")) : "";
        sendRequest({
            uri: "/sa/institution".concat(queryString),
            camelize: true
        }, applyResult, onError);
    }, [REDIRECT_URI]);
    useEffect(function () {
        if (state.selectedInstitution) {
            var applyResult = function () {
                window.location.href = "/insights/home";
            };
            sendRequest({
                uri: "/switch-institution/".concat(state.selectedInstitution),
                camelize: true
            }, applyResult);
        }
    }, [state.selectedInstitution]);
    useEffect(function () {
        if (state.institution.platformUuid !== "") {
            var applyResult = function (result) {
                if (result) {
                    dispatch(__assign(__assign({}, defaultAction), { type: "setInstitutionsList", institutionsList: result }));
                }
            };
            sendRequest({
                uri: "/sa/user-institutions",
                camelize: true
            }, applyResult);
        }
    }, [state.institution]);
    useEffect(function () {
        if (state.institution.navigatedFrom === "navigator") {
            var applyResult = function (result) {
                dispatch(__assign(__assign({}, defaultAction), { type: "setUser", user: result }));
                dispatch(__assign(__assign({}, defaultAction), { type: "setComponentLoaded", component: "membership" }));
            };
            sendRequest({ uri: "/sa/user_info", camelize: true }, applyResult);
        }
    }, [state.institution.navigatedFrom]);
    useEffect(function () {
        if (state.institution.navigatedFrom === "navigator" &&
            state.user &&
            state.user.gainsightData) {
            initiateGainsight(state.user.gainsightData);
        }
    }, [state.user]);
    useEffect(function () {
        var queryString = window.location.search;
        var param = new URLSearchParams(queryString);
        var paramlocale = param.get("locale");
        var tab = param.get("tab");
        var locale = paramlocale ? paramlocale : "";
        dispatch(__assign(__assign({}, defaultAction), { type: "setLocale", locale: locale }));
        dispatch(__assign(__assign({}, defaultAction), { type: "SetSelectedTabView", tab: tab || "" }));
    }, []);
    // Initial load of integrated products and CES user role for non-planning routes
    useEffect(function () {
        loadIntegratedProductsIfNeeded();
        loadCesUserRoleIfNeeded();
    }, [state.institution.platformUuid]);
    var onWmTabSelectedEvent = function (event) {
        if (event.detail.tabId === "labor-market-insights" &&
            state.institution.showLightcastPreview) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setComponentLoaded", component: "openPreviewModal" }));
            dispatch(__assign(__assign({}, defaultAction), { type: "setLightcastPreviewFlag", showLightcastPreview: false }));
        }
        dispatch(__assign(__assign({}, defaultAction), { type: "SetSelectedTabView", tab: event.detail.tabId }));
    };
    var setSelectedTabView = function (tabId) {
        dispatch(__assign(__assign({}, defaultAction), { type: "SetSelectedTabView", tab: tabId }));
    };
    var setIntegratedProducts = function (result) {
        dispatch(__assign(__assign({}, defaultAction), { type: "setIntegratedProducts", integratedProducts: result }));
    };
    var setOutcomesTerminology = function (result) {
        dispatch(__assign(__assign({}, defaultAction), { type: "setOutcomesTerminology", outcomesTerminology: result }));
    };
    var initialContext = {
        institution: state.institution,
        selectedTab: state.tab,
        onWmTabSelectedEvent: onWmTabSelectedEvent,
        sysUser: state.user,
        leads: state.leads,
        componentLoaded: state.componentLoaded,
        membership: state.membership,
        integratedProducts: state.integratedProducts,
        institutionsList: state.institutionsList,
        selectedInstitution: state.selectedInstitution,
        breadcrumb: state.breadcrumb,
        cesUserRole: state.cesUserRole,
        outcomesTerminology: state.outcomesTerminology,
        setBreadcrumb: function (breadcrumb) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setBreadcrumb", breadcrumb: breadcrumb }));
        },
        setSelectedInstitution: function (institution) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setSelectedInstitution", selectedInstitution: institution.uuid }));
        },
        setComponentLoaded: function (component) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setComponentLoaded", component: component }));
        },
        setleads: function (result) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setLeads", leads: result }));
        },
        setMembership: function (result) {
            dispatch(__assign(__assign({}, defaultAction), { type: "setMembership", membership: result }));
        },
        setOutcomesTerminology: setOutcomesTerminology,
        closePreviewModal: function () {
            var applyResult = function (result) { };
            sendRequest({ uri: "/lightcast/lightcast_preview_shown", camelize: true }, applyResult);
            dispatch(__assign(__assign({}, defaultAction), { type: "setPreviewModalStatus" }));
        }
    };
    var ifAdministrator = state.user.roles.includes("administrator");
    var ifInsightsContributor = state.user.roles.includes("contributor") &&
        state.user.roles.length === 1 &&
        state.institution.navigatedFrom === "navigator";
    useEffect(function () {
        if (ifInsightsContributor) {
            var applyResult = function (result) {
                dispatch(__assign(__assign({}, defaultAction), { type: "setNodeAccessContributor", nodeAccessContributor: result }));
            };
            sendRequest({ uri: "/sa/nodes_access", camelize: true }, applyResult);
        }
    }, [ifInsightsContributor]);
    var isContributorUserWithInstitutionAccess = ifInsightsContributor &&
        state.nodeAccessContributor !== null &&
        state.nodeAccessContributor.institution.length > 0;
    var isContributorUserWithOrganizationAccess = ifInsightsContributor &&
        state.nodeAccessContributor !== null &&
        state.nodeAccessContributor.organizations.length > 0;
    var authForPssHtml = state.institution.isPssIntegrated &&
        (isContributorUserWithInstitutionAccess || !ifInsightsContributor);
    var authForCESHtml = state.institution.showCourseEvaluation &&
        (isContributorUserWithInstitutionAccess ||
            isContributorUserWithOrganizationAccess ||
            !ifInsightsContributor);
    var authForSllHtml = ((_a = state.integratedProducts) === null || _a === void 0 ? void 0 : _a.some(function (product) { return product.id === "sll"; })) &&
        (isContributorUserWithInstitutionAccess || !ifInsightsContributor);
    var authForFacultyHtml = (_b = state.integratedProducts) === null || _b === void 0 ? void 0 : _b.some(function (product) {
        return product.id === "fs" &&
            (isContributorUserWithInstitutionAccess ||
                isContributorUserWithOrganizationAccess ||
                !ifInsightsContributor);
    });
    var isPSSUserOrLoadedInsightsUser = state.institution.navigatedFrom === "navigator"
        ? state.user && state.user.uuid !== ""
        : true;
    var orgProgramsPageAuth = ifAdministrator ||
        (ifInsightsContributor &&
            ((_c = state.institution) === null || _c === void 0 ? void 0 : _c.isSllSysAdminIntegrated) &&
            state.nodeAccessContributor !== null &&
            state.nodeAccessContributor.programs.length > 0);
    var institutionPageAuth = ifAdministrator || isContributorUserWithInstitutionAccess;
    var organizationPageAuth = ifAdministrator || isContributorUserWithOrganizationAccess;
    var isNodeAccessDataRequired = ifAdministrator ||
        (ifInsightsContributor && state.nodeAccessContributor) ||
        state.institution.navigatedFrom === "planning";
    var isPSSHtmlPage = function () {
        var path = window.location.pathname;
        return (path.endsWith("html") && state.institution.navigatedFrom === "planning");
    };
    var isMainComponentLoaded = function () {
        return (state.componentLoaded.institution &&
            (isPSSHtmlPage() ? true : state.componentLoaded.membership));
    };
    return (_jsxs(IntlProvider, { locale: state.locale, messages: state.messages, children: [state.showUnauthorized && _jsx(UnauthorizedComponent, {}), _jsxs(_Fragment, { children: [!isMainComponentLoaded() && _jsx(Loader, {}), _jsx(AppContext.Provider, { value: initialContext, children: state.nodeAccess ? (state.messages &&
                            state.institution &&
                            state.institution.platformUuid != "" &&
                            (state.integratedProducts || !hasSaIntegratedProducts()) &&
                            isNodeAccessDataRequired &&
                            (isPSSUserOrLoadedInsightsUser ? (_jsx(_Fragment, { children: _jsxs(Router, { children: [_jsx(SkipMenuManager, {}), _jsx(RouteChangeDetector, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "/insights/reporting_year/:reporting_year_uuid/plan/:plan_uuid/html", element: _jsx(PlanView, { auth: authForPssHtml }) }), _jsx(Route, { path: "/insights/labor_market/html", element: _jsx(LaborMarketExportView, { auth: authForPssHtml }) }), _jsx(Route, { path: "/insights/faculty_success/reporting_year/:reporting_year_uuid/mapping_id/:mapping_id/html", element: _jsx(FacultySuccessExportView, { auth: authForFacultyHtml }) }), _jsx(Route, { path: "/insights/institution-strategy/html", element: _jsx(MissionAndOutcomesExportView, { auth: authForPssHtml }) }), _jsx(Route, { path: "/insights/sll/reporting_year/:reporting_year_uuid/html", element: _jsx(SllExportView, { auth: authForSllHtml }) }), _jsx(Route, { path: "/insights/ces/survey/:survey_id/project/:project_id/html", element: _jsx(CesHtmlView, { auth: authForCESHtml }) }), _jsx(Route, { path: "/insights/academic_office", element: _jsx(InsightsHeaderSidebar, { user: state.user, children: _jsx(AcademicsAndOffices, { auth: ifAdministrator }) }) }), _jsx(Route, { path: "/insights/home", element: _jsx(InsightsHeaderSidebar, { user: state.user, children: _jsx(HomeComponent, {}) }) }), _jsx(Route, { path: "/insights/settings", element: _jsx(InsightsHeaderSidebar, { user: state.user, children: _jsx(InsightsSettings, { auth: ifAdministrator }) }) }), _jsx(Route, { path: "/insights/planning/institution/:institution_uuid/organization/:organization_uuid", element: _jsx(PlanningHeaderSidebar, { institution: state.institution, componentLoaded: state.componentLoaded, children: _jsx(OrgInsightsBody, { auth: state.institution.isPssIntegrated }) }) }), _jsx(Route, { path: "/insights/institution/:institution_uuid/program/:program_uuid", element: _jsx(InsightsHeaderSidebar, { user: state.user, hideNavigatorSideNav: true, children: _jsx(OrgInsightsBody, { auth: orgProgramsPageAuth }) }) }), _jsx(Route, { path: "/insights/institution/:institution_uuid/organization/:organization_uuid", element: _jsx(InsightsHeaderSidebar, { user: state.user, hideNavigatorSideNav: true, children: _jsx(OrgDetailComponent, { setSelectedTabView: setSelectedTabView, auth: organizationPageAuth }) }) }), _jsx(Route, { path: "/insights/institution/:institution_uuid", element: _jsx(InsightsHeaderSidebar, { user: state.user, hideNavigatorSideNav: true, children: _jsx(OrgProfileComponent, { setSelectedTabView: setSelectedTabView, auth: institutionPageAuth }) }) }), _jsx(Route, { path: "/insights/planning/home", element: _jsx(PlanningHeaderSidebar, { institution: state.institution, componentLoaded: state.componentLoaded, children: _jsx(Body, { setSelectedTabView: setSelectedTabView, auth: state.institution.isPssIntegrated }) }) }), process.env.NODE_ENV === 'development' && process.env.MIRAGE_ENV === 'true' && (_jsx(_Fragment, { children: _jsx(Route, { path: "/insights/mirage-state/manage", element: _jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(MirageStateComponent, {}) }) }) })), _jsx(Route, { path: "/insights/sitemap", element: _jsx(InsightsHeaderSidebar, { user: state.user, children: _jsx(SiteMap, {}) }) }), _jsx(Route, { path: "/insights/unauthorized", element: _jsx(UnauthorizedComponent, {}) }), _jsx(Route, { path: "/", element: _jsx(Navigate, { to: state.institution.navigatedFrom === "planning" ? "/insights/planning/home" : "/insights/home", replace: true }) }), _jsx(Route, { path: "*", element: _jsx(IncorrectURLComponent, {}) })] })] }) })) : (_jsx(Loader, {})))) : (_jsx(UnauthorizedComponent, {})) })] })] }));
}
export default App;
